import { Button, ButtonGroup, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material'
import React from 'react'
import styles from '../../styles/pages/user/content-buyer-accounting.module.scss'
import DeleteIcon from '../../ui/Icons/DeleteIcon'
import EyeviewIcon from '../../ui/Icons/EyeviewIcon'

const paymentHistoryTable = [
    {
        month: "March 2023",
        tableSubItem: [
            {
                amountRequest: "510",
                amountRequestDate: "Wednesday, March 16",
                paypal: "kmoore100@816qs.com",
                paidAmount: "510",
                paidAmountDate: "Friday, September 18",
                receivedAmount: "",
                receiptFileName: "",
            },
            {
                amountRequest: "510",
                amountRequestDate: "Wednesday, March 16",
                paypal: "kmoore100@816qs.com",
                paidAmount: "510",
                paidAmountDate: "Friday, March 18",
                receivedAmount: "",
                receiptFileName: "filenamnamie.png",
            },
            {
                amountRequest: "510",
                amountRequestDate: "Wednesday, March 16",
                paypal: "kmoore100@816qs.com",
                paidAmount: "510",
                paidAmountDate: "Friday, March 18",
                receivedAmount: "$490",
                receiptFileName: "receipt.png",
            },
        ]
    },
    {
        month: "February 2023",
        tableSubItem: [

        ],
    },
    {
        month: "January 2023",
        tableSubItem: [

        ],
    },
    {
        month: "December 2022",
        tableSubItem: [
            {
                amountRequest: "510",
                amountRequestDate: "Wednesday, March 16",
                paypal: "kmoore100@816qs.com",
                paidAmount: "510",
                paidAmountDate: "Friday, September 18",
                receivedAmount: "$490",
                receiptFileName: "",
            },
        ]
    },
]

const ContentbuyerAccountingPaymenthistoryTable = () => {
    return (
        <>
            <TableContainer>
                <Table className={styles.paymentHistoryTable} stickyHeader>
                    <TableHead>
                        <TableRow>
                            <TableCell className={styles.thMonth}>Month</TableCell>
                            <TableCell className={styles.thAmountrequest}>Amount Requested</TableCell>
                            <TableCell className={styles.thPaypal}>PayPal</TableCell>
                            <TableCell className={styles.thAmountPaid}>Amount Paid</TableCell>
                            <TableCell className={styles.thAmountReceived}>Amount Received</TableCell>
                            <TableCell className={styles.thPaymentReceipt}>Payment Receipt</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>

                        {paymentHistoryTable?.map((item) => {
                            return (
                                <>
                                    <TableRow className={styles.firstTr}>
                                        <TableCell colSpan={6}></TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell colSpan={6} className={`${styles.thMonth} ${styles.singleMonth}`}>
                                            <Typography variant='body1' className={styles.monthName}>{item?.month}</Typography>
                                        </TableCell>
                                    </TableRow>
                                    {item?.tableSubItem.length > 0 ? item?.tableSubItem.map((innerItem) => {
                                        return (
                                            <>
                                                <TableRow>
                                                    <TableCell className={styles.thMonth}>&nbsp;</TableCell>
                                                    <TableCell className={styles.thAmountrequest}>
                                                        <Typography variant='body2'>${innerItem?.amountRequest}</Typography>
                                                        <Typography variant='overline'>{innerItem?.amountRequestDate}</Typography>
                                                    </TableCell>
                                                    <TableCell className={styles.thPaypal}>
                                                        <Typography variant='body2'>{innerItem?.paypal}</Typography>
                                                    </TableCell>
                                                    <TableCell className={styles.thAmountPaid}>
                                                        <Typography variant='body2'>${innerItem?.paidAmount}</Typography>
                                                        <Typography variant='overline'>{innerItem?.paidAmountDate}</Typography>
                                                    </TableCell>
                                                    <TableCell className={styles.thAmountReceived}>
                                                        {innerItem?.receivedAmount ? (
                                                            <Typography variant='body2'>{innerItem?.receivedAmount}</Typography>
                                                        ) : (
                                                            <>
                                                                <Typography variant='body2'>-</Typography>
                                                            </>
                                                        )}

                                                    </TableCell>
                                                    <TableCell className={styles.thPaymentReceipt}>
                                                        {innerItem?.receiptFileName ? (
                                                            <Stack direction={'row'} alignItems={'center'} className={styles.payentFile}>
                                                                <Typography variant='caption'>{innerItem?.receiptFileName}</Typography>
                                                                <ButtonGroup>
                                                                    <Button><EyeviewIcon /></Button>
                                                                    <Button><DeleteIcon /></Button>
                                                                </ButtonGroup>
                                                            </Stack>
                                                        ) : (
                                                            <>
                                                                <Typography variant='body2'>-</Typography>
                                                            </>
                                                        )}
                                                    </TableCell>
                                                </TableRow>
                                            </>
                                        );
                                    }) : (
                                        <TableRow>
                                            <TableCell colSpan={6} align='center'>
                                                <Typography className={styles.emptymsg}>No transactions have been processed for this month.</Typography>
                                            </TableCell>
                                        </TableRow>
                                    )
                                    }
                                </>
                            );
                        })}

                    </TableBody>
                </Table>
            </TableContainer>
        </>
    )
}

export default ContentbuyerAccountingPaymenthistoryTable